<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>Add Quote</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-divider class="mx-20!" />

<div mat-dialog-content class="relative">
  @if (fileName && !fileDeleted && !quoteFiles?.length) {
    <div class="absolute right-0 result flex items-center px-15 py-10 mr-20 mt-5 bold subtitle-2 bg-wild-sand">
      <mat-icon class="mr-5 mt-[2px]">check_circle</mat-icon>
      EstImage found your Quote
    </div>
  }
  <mat-tab-group
    animationDuration="0ms"
    class="add-quote-tab"
    [selectedIndex]="selectedIndex"
    (selectedTabChange)="selectedIndex = $event.index">
    <mat-tab #fromFile>
      <ng-template mat-tab-label>
        <div [ngClass]="{ 'text-charcoal-50 subtitle-1': !fromFile.isActive, 'title-1': fromFile.isActive }">
          Import Quote
        </div>
      </ng-template>
      <div class="mt-20 import-container-file">
        @if (fileName) {
          <section class="file-box">
            <div class="file-container">
              <div class="delete-button-container secondary-icon">
                <mat-icon svgIcon="description"></mat-icon>
                <div>
                  <div class="received-date text-charcoal-10">
                    {{ lastModified / 1000 | dateepoch: timezone }} {{ lastModified / 1000 | time: timezone }}
                  </div>
                  <div class="file-name subtitle-2">
                    <span class="extra-margin">File</span>
                    <span class="subtitle-1 bold display-ellipsis">{{ fileName }}</span>
                  </div>
                </div>
              </div>
              <button
                type="button"
                matButton="elevated"
                class="charcoal-button w-36! min-w-36! p-0!"
                [disabled]="pendingImages()"
                (click)="deleteFile(quoteInput)">
                <mat-icon class="m-0!">delete_forever</mat-icon>
              </button>
            </div>
            @if (imageFiles?.length) {
              <mat-divider class="mt-10!"></mat-divider>
            }
            @if (pendingImages()) {
              <mat-progress-bar mode="indeterminate" class="my-20" />
            }
            @if (imageFiles?.length) {
              <mat-checkbox [checked]="uploadImages" (change)="uploadImages = $event.checked">
                EstImage found {{ imageFiles?.length | i18nPlural: imagesPluralMapping }} that can be uploaded along
                with the quote. Import these as well?
              </mat-checkbox>
            }
          </section>
        }
        @if (extractedVehicleData()) {
          <app-extracted-vehicle-details [data]="extractedVehicleData()" (importData)="importVehicleDetails = $event" />
        }
        @if (selectedIndex < 1) {
          <app-import-file-from-disk
            (setFile)="setFileFromHandler($event)"
            (setImages)="setImages($event)"
            [fileDeleted]="fileDeleted"
            [xmlFiles]="importQuoteFiles"
            [rego]="data?.rego"
            [type]="data?.type" />
        }
        @if (!fileName) {
          <div class="flex justify-center w-full pt-10 mb-20">
            <button matButton="elevated" class="charcoal-button w-200" type="button" (click)="quoteInput.click()">
              BROWSE
            </button>
          </div>
        }
        <input #quoteInput (change)="importQuote(quoteInput)" [hidden]="true" accept="text/xml" type="file" />
      </div>
    </mat-tab>
    <mat-tab #manualQuotes>
      <ng-template mat-tab-label>
        <div
          [ngClass]="{
            'text-charcoal-50 subtitle-1': !manualQuotes.isActive,
            'title-1': manualQuotes.isActive
          }">
          Manual Quote
        </div>
      </ng-template>
      <form [formGroup]="quoteForm" class="form-fields">
        @if (data.notAuthorised) {
          <mat-checkbox [checked]="importLastQuote.value" formControlName="importLastQuote" class="mt-20">
            Import the last quote
          </mat-checkbox>
        }
        <mat-form-field class="mt-20">
          <mat-label>Quote Number</mat-label>
          <input formControlName="quoteNumber" matInput required />
          @if (quoteNumber.invalid) {
            <mat-error> Quote Number is <strong>required</strong> </mat-error>
          }
        </mat-form-field>
      </form>
    </mat-tab>
  </mat-tab-group>
</div>

<mat-divider class="mx-20!" />

<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  <button
    matButton="elevated"
    class="red-button"
    type="submit"
    [disabled]="
      (quoteForm.invalid && manualQuotes.isActive) || pending() || pendingImages() || (fromFile.isActive && !fileName)
    "
    (click)="addQuote(manualQuotes.isActive)">
    ADD QUOTE
  </button>
</mat-dialog-actions>
